import * as React from "react";
import type { SVGProps } from "react";
const SvgSquareAcademicCap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21 15c0 .55.45 1 1 1s1-.45 1-1V9.02a.9.9 0 0 0-.06-.37c-.01-.02-.03-.07-.03-.07a1 1 0 0 0-.5-.49.1.1 0 0 0-.04-.02l-10-4a.95.95 0 0 0-.74 0l-10 4a1 1 0 0 0 0 1.86L5 11.278V16c0 2.28 3.01 4 7 4s7-1.72 7-4v-4.72l2-.8zm-4-2.92V16c0 .82-1.95 2-5 2s-5-1.18-5-2v-3.922l4.63 1.852c.24.1.5.1.74 0zm-5-.16L4.69 9 12 6.08 19.31 9z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSquareAcademicCap;
